import { GetterTree } from 'vuex'
import { RootState } from '../../types'

export const getters: GetterTree<RootState, RootState> = {
  isSending (state): boolean {
    return state.isSending
  }
}
